module.exports = __webpack_public_path__ + "static/img/my__location__icon.daf142c3.svg";